<template>
  <div id="app">
    <div class="bg"></div>
    <Header />
    <Auth-Popup ref="auth" />
    <div id="followBtn">
      <script
        src="https://platform.linkedin.com/in.js"
        type="application/javascript"
      >
        lang: en_US
      </script>
      <script type="IN/FollowCompany" data-id="14460031"></script>
    </div>
    <Maintenance-Screen v-if="$store.state.showMaintenanceScreen" />
    <router-view v-else />
  </div>
</template>

<script>
import { post, get } from '@/assets/util/rest.js'
import sharedFunctions from '@/assets/util/functions'
import { HttpUrl } from '@/assets/util/constants/analytics.js'
import AuthPopup from './components/authentication/AuthPopup'
import Header from '@/components/Header.vue'
import MaintenanceScreen from '@/views/MaintenanceView.vue'

export default {
  name: 'Home',
  data: function() {
    return {
      json: null
    }
  },
  components: {
    'Auth-Popup': AuthPopup,
    Header: Header,
    'Maintenance-Screen': MaintenanceScreen
  },
  methods: {
    addListenerForMsgFromPlugin() {
      const that = this
      window.addEventListener(
        'message',
        function(ev) {
          if (ev && ev.data && ev.data.type == 'li-warning') {
            sharedFunctions.track(
              'AP - LI Warning Message Shown',
              null,
              that.$store.state
            )
            that.saveDomToServer(ev.data.data)
          }
        },
        true
      )
    },
    saveDomToServer(data) {
      post('lp/logger.htm', {
        html: data
      })
    },
    fetchMemberDetails() {
      get(HttpUrl.getMemberDetails)
        .then(response => {
          if (response.status == 200)
            response.json().then(res => {
              if (res) {
                const {
                  lbCreditsPlan = false,
                  credits = 0,
                  views = 0,
                  downloads = 0,
                  email,
                  name = '',
                  phoneCredits,
                  lbCreditsAllotted,
                  phoneCreditsAllotted,
                  isPaidUser,
                  source,
                  registeredDate,
                  linkedin_follow,
                  uiVersion,
                  dailyLimit,
                  showSalesgearEarlyAccessPopup,
                  status = 2,
                  userType,
                  mobileNumberEnabled,
                  isCRMExportEnabled,
                  showMaintenanceScreen = false,
                  enableSalesNavigatorCompany = false
                } = res
                const skipMaintenanceScreen =
                  localStorage.getItem('skip_mc') === 'true'

                if (lbCreditsPlan) {
                  this.$store.state.header.credits = credits
                  this.$store.state.header.lbCreditsPlan = lbCreditsPlan
                } else {
                  this.$store.state.header.views = views
                  this.$store.state.header.downloads = downloads
                }
                this.$store.state.isCRMExportEnabled = isCRMExportEnabled
                this.$store.state.header.email = email
                this.$store.state.header.name = name
                this.$store.state.header.userType = userType
                this.$store.state.header.phoneCredits = phoneCredits
                this.$store.state.header.lbCreditsAllotted = lbCreditsAllotted
                this.$store.state.header.phoneCreditsAlloted = phoneCreditsAllotted
                this.$store.state.header.mobileNumberEnabled = mobileNumberEnabled
                this.$store.state.header.isPaidUser = isPaidUser
                this.$store.state.header.source = source
                this.$store.state.header.registeredDate = registeredDate
                this.$store.state.header.linkedinFollow = linkedin_follow
                this.$store.state.header.uiVersion = uiVersion
                this.$store.state.header.dailyLimit = dailyLimit
                this.$store.state.header.showSalesgearEarlyAccessPopup = showSalesgearEarlyAccessPopup
                this.$store.state.header.emailStatus = status
                this.$store.state.enableSalesNavigatorCompany = enableSalesNavigatorCompany
                this.$store.state.showMaintenanceScreen =
                  showMaintenanceScreen && !skipMaintenanceScreen
                localStorage.setItem('AP_USER_EMAIL', email)
                if (
                  window.location.pathname === '/company' &&
                  !this.$store.state.enableSalesNavigatorCompany
                ) {
                  window.location.href = '/custom'
                }
                localStorage.setItem(
                  'skipCompanyUrl',
                  String(!this.$store.state.enableSalesNavigatorCompany)
                )
                sharedFunctions.mixpanelIdentify(email)
              }
            })
        })
        .catch(e => {
          console.log('error: ' + e)
        })
    },
    checkAndRemoveInitSpinner() {
      setTimeout(function() {
        const dom = document.querySelector('#_init_load_')
        if (dom) {
          dom.parentElement.removeChild(dom)
        }
      }, 1000)
    }
  },
  created() {
    this.fetchMemberDetails()
  },
  beforeMount: function() {
    this.addListenerForMsgFromPlugin()
    this.checkAndRemoveInitSpinner()
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
}
#app {
  position: relative;
  width: 100%;
  min-height: 100%;
  #followBtn {
    display: block;
    position: fixed;
    z-index: -10;
    top: 0;
    opacity: 0;
  }
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 175px;
  z-index: -1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    filter: blur(75px);
    background: linear-gradient(to right, #fad6e8, #ccd4fd);
  }
}
</style>
